<template>
  <div class="networking-page">
    <div class="share-cta">
      <div class="heading">{{ activePage.heading_text }}</div>
      <p class="sub-heading">
        {{ activePage.intro_text }}
      </p>

      <div class="text-center">
        <v-btn
          elevation="0"
          class="share-memory-btn"
          color="#D11947"
          to="/sign-up"
          >Join the Network</v-btn
        >
      </div>
    </div>

    <div class="networking-page__grid">
      <div ref="grid">
        <SearchInput v-model="search" />
        <GridContact :items="contacts" />
        <infinite-loading :identifier="infiniteId" @infinite="fetchContacts">
          <div slot="no-more"></div>
          <div slot="no-results" class="no-results">Nothing found</div>
          <div slot="spinner">
            <Spinner />
          </div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "NetworkingPage",
  metaInfo: {
    titleTemplate: "%s - Networking Lounge"
  },
  data() {
    return {
      search: "",
      contacts: [],
      page: 1,
      infiniteId: +new Date(),
      pageSlug: "networking",
      teamIds: [],
      teams: [
        {
          id: "staff",
          name: "Staff"
        },
        {
          id: "all_volunteers",
          name: "All Volunteers"
        },
        {
          id: "heroes",
          name: "St. Jude Heroes"
        },
        {
          id: "team_members",
          name: "National & Multi-Market Team Members"
        },
        {
          id: "walk_run",
          name: "St. Jude Walk/Run"
        }
      ]
    };
  },
  mounted() {
    this.setPageContext("networking", () => {
      this.fetchResource("Contact");
      console.info("this", this);
    });
  },
  methods: {
    async fetchContacts($state) {
      console.info("fetchContacts");
      const params = {
        page: this.page,
        query: this.search,
        page_slug: this.pageSlug,
        teams: _.compact(this.teamIds)
      };
      console.info("fetchContacts params", params);

      const { data } = await this.$api.Contact.query(params);
      console.info("fetchContacts data", data);
      this.page += 1;
      const ids = this.contacts.map(t => t.id);
      const newData = data.filter(t => !ids.includes(t.id));

      this.contacts.push(...newData);

      if (data.length) {
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    setInfiniteId: _.debounce(function() {
      this.page = 1;
      this.contacts = [];
      this.infiniteId += 1;
    }, 300)
  },
  watch: {
    search() {
      this.setInfiniteId();
    }
  }
};
</script>

<style scoped lang="scss">
.networking-page {
  background-color: #f5f5f5;

  &__grid {
    min-height: 200px;
    position: relative;
  }

  .share-memory-btn {
    color: white;
  }
  .share-cta {
    text-align: center;
    padding: 54px 15% 45px;
    color: $primary;

    .heading {
      font-weight: 800;
      font-size: 64px;
      line-height: 1.14;
    }

    .sub-heading {
      font-size: 18px;
      line-height: 24px;
      margin: 15px 0 34px;
    }
  }

  &__filter-tip {
    font-style: italic;
    font-weight: 400;
    font-size: 14px;
    color: #8b8b8b;
    text-align: center;
    margin: 11px 0 39px;
  }
}

@media screen and (max-width: 960px) {
  .networking-page {
    .share-cta {
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 30px;
      .heading {
        font-size: 48px;
      }
    }
    &::v-deep {
      .v-btn:not(.v-btn--round).v-size--default.share-memory-btn {
        font-size: 16px;
        height: 36px;
        padding: 0 22px;
      }
    }
    &__filter-tip {
      margin-bottom: 25px;
    }
  }
}
</style>
